import { h } from 'preact';
import MaterialComponent from '../Base/MaterialComponent';
export class Icon extends MaterialComponent {
    constructor() {
        super(...arguments);
        this.componentName = 'icon';
        this.mdcProps = [];
    }
    materialDom(props) {
        const classes = ['material-icons'];
        // CardActionIcon sends className
        if (props.className) {
            classes.push(props.className);
        }
        return (h("i", Object.assign({}, props, { className: classes.join(' ') }), props.children));
    }
}
export default Icon;
//# sourceMappingURL=index.js.map